export const LOGO_URL =
  'https://img.usecurling.com/i?q=Viveiro%20Floresta%20Logo%20Trees&color=green&shape=hand-drawn'

// Global WhatsApp Configuration
export const WHATSAPP_NUMBER =
  import.meta.env.VITE_WHATSAPP_NUMBER || '5564984536263'
export const WHATSAPP_MESSAGE =
  'Olá! Gostaria de saber mais sobre os projetos de paisagismo.'
